// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/feed/components/FeedCategoryBadge.module.css';
import {FeedCategoryIcon} from '@app/features/feed/components/FeedCategoryIcon';
import {openFeedCategory, shownFeedCategories} from '@app/features/feed/utils/FeedCategoryUtils';
import type {FeedPostCategoryResponse} from '@fluxer/schema/src/domains/feed/FeedCategorySchemas';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

// Micup akis-kategori: the category of a post in its header row. A plain inline label (no measuring, no motion, no
// portal), opening the category only while the list offers it (open, and shown in the viewer's country).
// onOpen runs first, so a card inside a modal closes the modal.
export const FeedCategoryBadge = observer(
	({category, onOpen}: {category: FeedPostCategoryResponse; onOpen?: () => void}) => {
		const content = (
			<>
				<FeedCategoryIcon emoji={category.emoji} className={styles.icon} data-flx="feed.feed-category-badge.icon" />
				<span className={styles.name} data-flx="feed.feed-category-badge.name">
					{category.name}
				</span>
			</>
		);
		if (!shownFeedCategories().some((shown) => shown.id === category.id)) {
			return (
				<span className={styles.badge} data-flx="feed.feed-category-badge.badge">
					{content}
				</span>
			);
		}
		const open = () => {
			onOpen?.();
			openFeedCategory(category.id);
		};
		return (
			<button
				type="button"
				className={clsx(styles.badge, styles.openable)}
				onClick={open}
				data-flx="feed.feed-category-badge.badge"
			>
				{content}
			</button>
		);
	},
);
